import React, { Fragment } from 'react'
import { uniqBy, filter, meanBy, round, sumBy, some, groupBy } from 'lodash'
import Table from 'UI/Table'
import Icon from 'UI/FontAwesomeIcon'

import { groupedCustomerData, groupedDomainData } from './Data'

const ActiveDirectoryTable = ({ data }) => (
  <Table {...{
    data: groupedCustomerData(filter(data, ['ad_server', 1])),
    filterable: true,
    columns: [
      { Header: 'Customer', accessor: 'customer_name', type: 'clientNameWithStatus' },
      { Header: 'Total Devices', type: 'number', id: 'totalDevices', accessor: ({ assets }) => assets.length, Footer: ({ data }) => sumBy(data, 'totalDevices').toLocaleString() },
      { Header: 'Total Domains', type: 'number', id: 'totalDomains', accessor: ({ assets }) => uniqBy(assets, 'domain').length, Footer: ({ data }) => sumBy(data, 'totalDomains').toLocaleString() },
      {
        id: 'totalADUsers',
        Header: 'Total Users',
        type: 'number',
        Footer: ({ data }) => sumBy(data, 'totalADUsers').toLocaleString(),
        accessor: ({ assets }) => round(
          sumBy(
            groupedDomainData(assets),
            ({ assets }) => meanBy(assets, ({ ad_user_total }) => parseInt(ad_user_total || 0))
          )
        ),
        Cell: (data) => {
          if (some(groupBy(data.original.assets, 'domain'), assets => uniqBy(assets, 'ad_user_total').length > 1)) {
            return (
              <span style={{ color: 'red' }}>
                <Icon icon={'exclamation-triangle'} /> {data.value}
              </span>
            )
          }

          return data.value
        }
      }
    ],
    SubComponent: (row) => (
      <Table {...{
        data: groupedDomainData(row.original.assets),
        showPagination: false,
        defaultPageSize: row.original.assets.length,
        filterable: true,
        columns: [
          { Header: 'Domain', accessor: 'domain' },
          { Header: 'Total Domain Controllers', id: 'totalDomainControllers', accessor: ({ assets }) => assets.length, Footer: ({ data }) => sumBy(data, 'totalDomainControllers').toLocaleString() },
          {
            id: 'totalADUsers',
            Header: 'Total Users',
            accessor: ({ assets }) => round(meanBy(assets, ({ ad_user_total }) => parseInt(ad_user_total || 0))),
            type: 'number',
            Footer: ({ data }) => sumBy(data, 'totalADUsers').toLocaleString(),
            Cell: (data) => {
              if (uniqBy(data.original.assets, 'ad_user_total').length > 1) {
                return (
                  <Fragment>
                    {data.value}
                    <br />
                    <span style={{ color: 'red' }}>
                      <Icon icon={'exclamation-triangle'} />
                      <em>The amount of users per device is not equal</em>
                    </span>
                  </Fragment>
                )
              }

              return data.value
            },
          }
        ],
        SubComponent: (row) => (
          <Table {...{
            data: row.original.assets,
            showPagination: false,
            defaultPageSize: row.original.assets.length,
            columns: [
              { Header: 'Domain Controller', accessor: 'device_name' },
              { Header: 'Power', accessor: 'power_state', type: 'powerState' },
              { Header: 'Total AD Users', accessor: 'ad_user_total', type: 'number' },
              { Header: 'Operating System', accessor: 'operating_system' },
            ]
          }} />
        )
      }} />
    )
  }} />
)

export default ActiveDirectoryTable
